import React, { useEffect, useState } from "react";
import { AlertState } from "../global/AlertState";
import { useRecoilState } from "recoil";

const Alert = () => {
  const [message, setMessage] = useRecoilState(AlertState);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertClass, setAlertClass] = useState(false);

  const handleClose = () => {
    setMessage("");
    return () => clearTimeout(0);
  };

  useEffect(() => {
    if (message) {
      const [msg, isSuccess] = message?.split("|");
      setAlertMsg(msg);
      setAlertClass(isSuccess === "true");
      const timer = setTimeout(() => {
        handleClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [message, setMessage]);

  if (!message) return null;

  return (
    message !== "" && (
      <div
        style={{
          position: "fixed",
          top: "15%",
          right: "2%",
          width: "30%",
          zIndex: 99999,
        }}
      >
        <div
          className={`alert alert-dismissible fade show ${
            alertClass ? "alert-success" : "alert-danger"
          }`}
          role="alert"
        >
          {alertMsg}
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleClose}
          ></button>
        </div>
      </div>
    )
  );
};

export default Alert;
